var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": _vm.url
    }
  }, [_c('i', {
    class: _vm.icon
  }), _vm._v(" " + _vm._s(_vm.name) + "\n  "), _c('b-badge', {
    attrs: {
      "variant": _vm.badge.variant
    }
  }, [_vm._v(_vm._s(_vm.badge.text))])], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-879cffcc","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SidebarNavLink.vue
// module id = 368
// module chunks = 1